import {
  GoogleAuthProvider,
  browserLocalPersistence,
  setPersistence,
  signInWithPopup,
} from 'firebase/auth';

export function createFirebaseAuthDataSource() {
  return {
    async signInWithGoogle(auth) {
      if (!auth) {
        throw new Error('Auth no inicializado. Recargá la página.');
      }
      try {
        await setPersistence(auth, browserLocalPersistence);
      } catch (_e) {
        /* seguir: en web el default suele ser local ya */
      }
      const provider = new GoogleAuthProvider();
      const cred = await signInWithPopup(auth, provider);
      return cred?.user || null;
    },
  };
}
